// import external dependencies
import 'bootstrap';
import 'picturefill'; // import local dependencies

import Router from './util/Router';
import common from './routes/common';
import ResponsiveBackgroundImage from './util/ResponsiveBackgroundImage';
import './sw';
/** Populate Router instance with DOM routes */

const routes = new Router({
  // All pages
  common
}); // Load Events

jQuery(document).ready(() => routes.loadEvents());
const responsiveBackgroundImages = document.querySelectorAll('[data-responsive-background-image]');

for (let i = 0; i < responsiveBackgroundImages.length; i++) {
  new ResponsiveBackgroundImage(responsiveBackgroundImages[i]);
}


// WEBPACK FOOTER //
// resources/assets/scripts/main.js